export { CorporativoLandingTelco } from "./CorporativoLandingTelco";
